function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["allowTargetAttribute", "allowIframeTag", "children", "withSanitize"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
/* eslint-disable react/jsx-props-no-spreading */
import dompurify from "isomorphic-dompurify";
import { Text } from "./Text";
var DangerousText = Text;

/**
 * The types of the props that are used in the TextWithDangerouslyInnerHtml component
 */

/**
 * The type of all the props of the TextWithDangerouslyInnerHtml component, including the ones of the tag prop
 */

/**
 * The 2 types of the TextWithDangerouslyInnerHtml component
 */

// eslint-disable-next-line react/function-component-definition
export function TextWithDangerouslyInnerHtml(_ref) {
  var _ref$allowTargetAttri = _ref.allowTargetAttribute,
    allowTargetAttribute = _ref$allowTargetAttri === void 0 ? false : _ref$allowTargetAttri,
    _ref$allowIframeTag = _ref.allowIframeTag,
    allowIframeTag = _ref$allowIframeTag === void 0 ? false : _ref$allowIframeTag,
    children = _ref.children,
    _ref$withSanitize = _ref.withSanitize,
    withSanitize = _ref$withSanitize === void 0 ? true : _ref$withSanitize,
    rest = _objectWithoutProperties(_ref, _excluded);
  var sanitizeConfig = {
    ADD_TAGS: [],
    ADD_ATTR: []
  };
  if (allowTargetAttribute) {
    sanitizeConfig.ADD_ATTR.push("target");
  }
  if (allowIframeTag) {
    sanitizeConfig.ADD_TAGS.push("iframe");
    sanitizeConfig.ADD_ATTR.push("allow", "allowfullscreen", "frameborder", "scrolling");
  }
  var props = _objectSpread(_objectSpread({}, rest), children && {
    dangerouslySetInnerHTML: {
      __html: withSanitize ? dompurify.sanitize(children, sanitizeConfig) : children
    }
  });
  return /*#__PURE__*/React.createElement(DangerousText, props);
}